import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { contentPropTypes } from 'Types'
import config from 'Config'
import { getIsSponsored } from 'Utils'
import { Banner, TopProducts, TwinArticles, TheLook, Archive, LatestArticles } from 'Blocks'
import get from 'lodash/get'

const HubTargetWrapper = props => {
    const { hub, screenType, isIOS } = props
    const { layout = [],  title, uuid } = hub

    const mylayout = () =>
        Object.keys(layout)
          .filter(mytype => mytype !== '__typename')
          .map(type => layout[type])
          .reduce((acc, curr) => acc.concat(curr))
          .sort((a, b) => a.position - b.position)
          .map(obj => ({
            ...obj,
            __typename: obj.__typename.replace('ContentLayout', '')
          }))

    return (
        <Fragment>
            {mylayout().map((item, index) => {
                switch (item.__typename) {
                    case 'Banner':
                        return <Banner key={`el-${uuid}-${index}`} data={item} screenType={props.screenType} isIOS={isIOS}  />
                    case 'TopProducts':
                        return <TopProducts key={`el-${uuid}-${index}`} data={item} screenType={props.screenType}  />
                    case 'TwinArticles':
                        return <TwinArticles key={`el-${uuid}-${index}`} data={item} screenType={props.screenType}  />
                    case 'TheLook':
                        return <TheLook key={`el-${uuid}-${index}`} data={item} screenType={props.screenType}  />
                    case 'LatestArticles':
                        return <LatestArticles key={`el-${uuid}-${index}`} data={item} screenType={props.screenType}  />
                    default:
                }
            })}
            <Archive {...props} pagination={false} />
        </Fragment>
    )
    
}

HubTargetWrapper.propTypes = {
    hub: PropTypes.shape(contentPropTypes),
    location: PropTypes.shape({
        search: PropTypes.any
    }),
}
  
export default HubTargetWrapper
